import React from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { colors } from "UI/colors";
import { scrollbarLightThin } from "UI/scrollbarStyles";

import NameEntry from "./NameEntry";

export default function NamesList({ data, isExpanded }) {
  const list = {
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
      },
    },
    hidden: {
      opacity: 0,
    },
  };

  if (!data || !isExpanded) return null;

  return (
    <List initial="hidden" animate="visible" variants={list}>
      <Message>
        Select a member below to review their duplicate profiles.
      </Message>
      <ListInner>
        {data.map((entry) => (
          <NameEntry key={entry.duplicateID} {...entry} />
        ))}
      </ListInner>
    </List>
  );
}

const List = styled(motion.div)`
  overflow: hidden;
  padding: 5px 0 0;
`;

const Message = styled.div`
  font-weight: 400;
  font-size: 13px;
  padding: 2px 10px 5px;
  color: ${colors.fnDkBlue};
`;

const ListInner = styled.div`
  max-height: 600px; // this should fit 10 entries before scrollbars show up
  overflow-y: auto;
  ${scrollbarLightThin};
`;
